// Dependencies
import React from 'react';

if (process.env.NODE_ENV !== 'test') {
  require('./Modal.scss');
}

/**
 * The modal is always open - if it is in the DOM it is visible.
 * Use a ternary condition in render to hide it.
 *
 * Takes two props and children:
 * - handleHideModal: A function to be fired when the user wishes to close
 *   the modal. (You need to set the `open` prop to false yourself).
 * - children: The content of the modal.
 */
export default class Modal extends React.Component {
  interval = null;

  componentDidMount() {
    this.updateWindowClassAndState(true);

    // When hiding another modal and showing the next,
    // the next modal will not properly set the class
    // on the body, as mount happens before unmount.
    //
    // Set an interval to fix this.
    this.interval = setInterval(() => {
      this.updateWindowClassAndState(true);
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.updateWindowClassAndState(false);
  }

  hideModal(e) {
    // Only allow closing of modal when clicking outside or on cross (X)
    // It IS .contains, not .includes for DOMTokenLists
    if (
      !e.target.classList.contains('modal-close') &&
      !e.target.classList.contains('modal-fade-screen')
    ) {
      return;
    }

    // Remove class that disbles scrolling on body
    this.updateWindowClassAndState();
    this.props.handleHideModal();
  }

  updateWindowClassAndState(setClass) {
    const body = document.getElementsByTagName('body')[0];
    if (setClass) {
      // Scroll to top so modal does not have a gap below it
      window.scrollTo(0, 0);

      // Don't manupulate the DOM if we don't need to
      if (body.classList.contains('modal-is-open')) {
        return;
      }

      body.classList.add('modal-is-open');
    } else {
      body.classList.remove('modal-is-open');
    }
  }

  render() {
    return (
      <div className="Modal modal-open">
        <div className="modal-fade-screen" onClick={e => this.hideModal(e)}>
          <div className="modal-inner">
            <div className="modal-close" />
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
